import { FC } from 'react';
import { createSelector } from '@reduxjs/toolkit';
import { featuresSelector } from '@/support/Selectors';
import { useSelector } from 'react-redux';
import { DisplayDatatable } from '@/components/Studies/DataTables/Display/DisplayDatatable';
import { DataTableView } from '@/components/UI/DataTableV2/DataTableView';
import { useParams } from 'react-router-dom';
import { _notNil } from '@/littledash';
import { DataTableProvider } from '@/components/UI/DataTableV2/DataTableProvider';
import { isApiId } from '@/utils/ApiId.utils';

const sampleSheetsEnabledSelector = createSelector([featuresSelector], (features) => features.sampling_sheets === true);

export const DatatableVersionSelector: FC = () => {
  const { id: studyId, dataTableId: dataTableApiId } = useParams<{ id: string; dataTableId: string }>();
  const sampleSheetsEnabled = useSelector(sampleSheetsEnabledSelector);
  if (sampleSheetsEnabled) {
    if (_notNil(studyId) && isApiId('dtl', dataTableApiId)) {
      return (
        <DataTableProvider studyId={studyId} dataTableApiId={dataTableApiId}>
          <DataTableView />
        </DataTableProvider>
      );
    }
    return null;
  }
  return <DisplayDatatable />;
};
